import { z } from "zod";

type HSL = { hue: number; saturation: number; light: number };
const hslZodSchema = z.object({
    hue: z.number().min(0).max(360),
    saturation: z.number().min(0).max(1),
    light: z.number().min(0).max(1),
});

export type { HSL };
export { hslZodSchema };
